import { v4 as uuidv4 } from "uuid";

const TRACE_ID_STORAGE_KEY = "traceId";

export const getTraceId = () => {
  const stored = sessionStorage.getItem(TRACE_ID_STORAGE_KEY);
  if (stored) return stored;
  const id = uuidv4();
  sessionStorage.setItem(TRACE_ID_STORAGE_KEY, id);
  return id;
};
